import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import Testimonials from "@/components/home/Testimonials";
import { Chapter, Reveal } from "@/components/motion";
import { IMAGES, WHY_POINTS } from "@/data/site";

const PILLARS = ["Communication.", "Accountability.", "Consistency.", "Performance."];

export default function WhyFormcore() {
  return (
    <div data-testid="why-page">
      <PageHero
        index="05"
        label="Why Formcore"
        titleLines={["Why Construction Businesses", { t: "Choose Formcore.", c: "text-gold" }]}
        intro="Formcore isn't simply supplying labour. Formcore provides professionally managed construction workforces — built on experience, selection, training, safety, management capability and client responsiveness."
        image={IMAGES.bridge}
      />

      <section className="bg-white py-28 lg:py-32">
        <div className="mx-auto max-w-7xl px-6">
          <div className="border-t border-navy/10">
            {WHY_POINTS.map((point, i) => (
              <Reveal key={point.title} y={20}>
                <div
                  className="group grid items-start gap-4 border-b border-navy/10 py-8 transition-colors duration-300 hover:bg-surface md:grid-cols-12 md:gap-8 md:px-4"
                  data-testid={`why-reason-${i}`}
                >
                  <span className="font-heading text-2xl font-extrabold text-gold md:col-span-1">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="font-heading text-xl font-extrabold tracking-tight text-navy md:col-span-4 md:text-2xl">
                    {point.title}
                  </h2>
                  <p className="text-sm leading-relaxed text-charcoal/70 md:col-span-6">{point.text}</p>
                  <ArrowUpRight className="hidden h-5 w-5 text-navy/20 transition-colors duration-300 group-hover:text-gold md:col-span-1 md:block" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-navy py-28 lg:py-32">
        <div className="absolute inset-0 bg-blueprint-dark opacity-30" />
        <div className="relative z-10 mx-auto max-w-7xl px-6">
          <Chapter index="02" label="Client Satisfaction" dark />
          <Reveal delay={0.1}>
            <h2 className="mt-8 max-w-3xl font-heading text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl">
              Your Project. Your Requirements. <span className="text-gold">Our Responsibility.</span>
            </h2>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70">
              Every client has different requirements. Formcore takes the time to understand the nature of the project,
              the required workforce, the working environment and the expectations of the client. Our goal is not simply
              to fill a vacancy — it is to establish long-term relationships by consistently delivering value.
            </p>
          </Reveal>
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {PILLARS.map((pillar, i) => (
              <Reveal key={pillar} delay={i * 0.08}>
                <div className="border-l-4 border-gold bg-white/[0.04] p-7">
                  <span className="font-heading text-xs font-bold text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <p className="mt-3 font-heading text-xl font-extrabold tracking-tight text-white">{pillar}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Testimonials />
      <CTASection title="Experience the Formcore Difference" />
    </div>
  );
}
